import React from 'react'

import Entry from './Entry'

export default props => {
  const { updateState, channels, query, onSubmit } = props

  const lowerQuery = query.toLowerCase()
  // channel.name and channel.type are here for migration purposes.
  // They can be removed once everybody uses the new Slack integration
  // with the public api
  return (
    <div style={{ height: 240 }} className="scroll-y">
      {channels
        .filter(channel => {
          const label = channel.name || channel.label

          return label.toLowerCase().includes(lowerQuery)
        })
        .map(channel => {
          return (
            <Entry
              key={channel.value}
              onSelect={() => updateState(channel)}
              onSubmit={() => onSubmit(channel)}
              title={channel.name || channel.label}
              type={channel.type || channel.privacy}
            />
          )
        })}
    </div>
  )
}
